import React from "react";
import NewsletterThirtyThree from "../component/NewsletterThirtyThree";

function NewsletterThirtyThreeContainer() {
  return <NewsletterThirtyThree />;
}

export default NewsletterThirtyThreeContainer;
